import { types } from 'k-ramel'

export default {
  data: {
    clients: types.keyValue(),
    invoices: types.keyValue(),
  },
  ui: {
    invoice: types.object(),
  },
}
